// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"46":"3942c698","50":"6c57355c","163":"7c9b669b","237":"7da70f61","283":"f6420047","384":"44ea44ba","427":"9b3eb695","521":"72632fe2","569":"63a3ca96","617":"9d17d2eb","744":"9eb71c3d","850":"90984b56","852":"c51bcb54","968":"cab1d097","994":"2910f401"}[chunkId] + ".chunk.js";
};